import { render, staticRenderFns } from "./TributeUploadModal.vue?vue&type=template&id=440adacd"
import script from "./TributeUploadModal.vue?vue&type=script&lang=js"
export * from "./TributeUploadModal.vue?vue&type=script&lang=js"
import style0 from "./TributeUploadModal.vue?vue&type=style&index=0&id=440adacd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports